module.exports = __webpack_public_path__ + "img/hammer.c6d3af5a.jpg";